import { HiLockClosed } from 'react-icons/hi2';
import { useState } from 'react';
import ShieldImage from '../assets/Onboarding/ShieldImage.svg';
import { RxCross1 } from 'react-icons/rx';
import { Button } from './ui/button';
import { Dialog, DialogContent } from './ui/dialog';

export const SecureServiceMessage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col text-center text-sm my-4 bg-white/50 p-3 mx-4 rounded-xl w-full">
        <div className="flex w-full justify-center items-center">
          <HiLockClosed className="w-4 h-4 mr-1" />
          <p className="font-medium">
            Aldebaran est un{' '}
            <span
              className="underline cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            >
              service sécurisé
            </span>
            .
          </p>
        </div>
        <p className="font-light">
          Seul votre médecin peut consulter vos réponses.
        </p>
      </div>

      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent>
          <div className="flex flex-col flex-1 min-h-0 px-6 pb-5 pt-3">
            <div className="flex justify-end">
              <button
                className="shrink-0 hover:bg-gray-200 cursor-pointer p-1 rounded-lg"
                onClick={() => setIsModalOpen(false)}
              >
                <RxCross1 className="size-5" />
              </button>
            </div>
            <div className="flex flex-col justify-start flex-1 min-h-0 overflow-y-auto no-scrollbar">
              <img
                src={ShieldImage}
                alt="Bouclier"
                className="size-32 mb-6 mx-auto shrink-0"
              />
              <div className="flex flex-col gap-3">
                <p className="text-3.5xl font-semibold">
                  L&apos;assistant de confiance <br /> de votre médecin
                </p>
                <p className="leading-5.5">
                  Aldebaran est un service sécurisé conformément aux
                  réglementations européennes en vigueur. <br />
                  <br /> Les données du questionnaire sont transmises en
                  conformité avec les exigences strictes du RGPD et hébergées en
                  France sur des serveurs certifiés HDS afin de protéger la vie
                  privée des patients.
                </p>
                <a
                  href="https://aldebaran.care/legal/politique-protection-donnees"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm underline font-light focus:outline-none focus:ring-0"
                >
                  En savoir plus la protection des données
                </a>
              </div>
            </div>
            <div className="flex flex-col w-full items-center nsm:px-2 pt-4 shrink-0">
              <Button
                variant="ctaPrimary"
                size="lg"
                onClick={() => setIsModalOpen(false)}
              >
                Compris
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
